import React from 'react'
import './chipbutton.css'

const renderCount = (count) => {
  if(count && count > 0){
    return (
      <span className="chip-button__badge">{count}</span>
    )
  }
}

function index({ children, selected, count, ...props }) {
  return (
    <button {...props} className={`${props.className} chip-button__btn ${selected ? 'selected' : ''}`}>
      {children}
      {/* {(count && count > 0) && (
        <span className="chip-button__badge">{count}</span>
      )} */}
      {renderCount(count)}
    </button>
  )
}

export default index


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/chip button/index.js